<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-28 10:37:51
 * @LastEditTime: 2022-03-03 11:27:40
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="
        type === 'edit'
          ? $t('lang.alarmNotice.EditingAlarm')
          : $t('lang.alarmNotice.Addalarm')
      "
      :visible.sync="dialogVisible"
      center
    >
      <div class="alarm-form">
        <el-form
          :model="alarmNotice"
          ref="alarmNotice"
          :rules="rules"
          label-position="right"
          label-width="140px"
        >
          <el-form-item
            :label="$t('lang.alarmNotice.eventName')"
            prop="noticeName"
          >
            <el-input
              class="form-input"
              size="mini"
              clearable
              v-model="alarmNotice.noticeName"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.alarmNotice.way')" prop="mode">
            <el-checkbox-group v-model="alarmNotice.mode">
              <el-checkbox :label="1">{{
                $t("lang.alarmNotice.email")
              }}</el-checkbox>
              <!-- <el-checkbox :label="2">短信</el-checkbox>
              <el-checkbox :label="3">微信</el-checkbox> -->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('lang.alarmNotice.Alarmterminal')">
            <select-terminals
              ref="selectTerminal"
              :terminal="terminalSelections"
            ></select-terminals>
          </el-form-item>
          <el-form-item :label="$t('lang.alarmNotice.AlarmContact')">
            <select-contact
              ref="selectContact"
              :contact="contactSeletions"
            ></select-contact>
          </el-form-item>
          <el-form-item
            :label="$t('lang.alarmNotice.pushMechanism')"
            prop="pushMode"
          >
            <el-radio-group v-model="alarmNotice.pushMode">
              <el-radio :label="1">{{ $t("lang.alarmNotice.once") }}</el-radio>
              <el-radio :label="2">{{
                $t("lang.alarmNotice.repeatedly")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$t('lang.alarmNotice.timeInterval')"
            v-if="alarmNotice.pushMode == 2"
          >
            <el-select
              default-first-option
              filterable
              allow-create
              class="form-input"
              size="mini"
              clearable
              v-model="alarmNotice.pushInterval"
            >
              <el-option label="10" :value="10"></el-option>
              <el-option label="30" :value="30"></el-option>
              <el-option label="60" :value="60"></el-option>
            </el-select>
            <span style="color: grey; margin-left: 10px">{{
              $t("lang.alarmNotice.minute")
            }}</span>
          </el-form-item>
          <el-form-item :label="$t('lang.alarmNotice.state')" prop="status">
            <el-radio-group v-model="alarmNotice.status">
              <el-radio :label="1">{{
                $t("lang.alarmNotice.enable")
              }}</el-radio>
              <el-radio :label="0">{{
                $t("lang.alarmNotice.disabled")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.Button.cancel")
        }}</el-button>
        <el-button type="primary" size="mini" @click="submitForm">{{
          $t("lang.Button.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { pushModeOptions } from "@/utils/alarmConfig";
import devicesTable from "./devicesTable";
import { cloneDeep, uniqBy, findIndex } from "lodash";
import { addAlarmNotice, editAlarmNotice } from "@/api/cloudMonitor/alarmList";
import { getuser_id } from "@/localStorage/localStorage";
import selectTerminals from "./selectTerminals";
import selectContact from "./selectContact";
export default {
  components: {
    devicesTable,
    selectTerminals,
    selectContact,
  },
  data() {
    return {
      pushModeOptions,
      dialogVisible: false,
      type: "",
      terminalSelections: [],
      contactSeletions: [],
      contactMap: new Map(),
      alarmNotice: {
        uid: getuser_id(),
        noticeName: "",
        mode: [1],
        pushMode: 1,
        status: 0,
        pushInterval: 10,
      },
      rules: {
        noticeName: [
          {
            required: true,
            message: this.$t("lang.alarmNotice.msg1"),
            trigger: "blur",
          },
        ],
        mode: [
          {
            type: "array",
            required: true,
            message: this.$t("lang.alarmNotice.msg2"),
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    clearData() {
      this.alarmNotice = {
        uid: getuser_id(),
        noticeName: "",
        mode: [1],
        pushMode: 1,
        status: 0,
        pushInterval: 10,
      };
      this.terminalSelections = [];
      this.contactSeletions = [];
      this.contactMap.set([1], 1);
      this.contactMap.set([2], 2);
      this.contactMap.set([3], 4);
      this.contactMap.set([1, 3], 5);
      this.contactMap.set([1, 2], 3);
      this.contactMap.set([2, 3], 6);
      this.contactMap.set([1, 2, 3], 7);
    },
    show(item) {
      this.clearData();
      if (item) {
        console.log("item");
        console.log(item);
        this.type = "edit";
        this.alarmNotice = cloneDeep(item);
        this.terminalSelections = item.dtus;
        this.contactSeletions = item.alarmContacts;
        this.alarmNotice.status = this.alarmNotice.status ? 1 : 0;
        for (let [key, value] of this.contactMap) {
          if (item.mode == value) {
            this.alarmNotice.mode = key;
          }
        }
      } else {
        this.type = "add";
      }
      this.dialogVisible = true;
    },
    // 提交表单
    submitForm() {
      this.$refs.alarmNotice.validate((valid) => {
        if (valid) {
          this.terminalSelections = this.$refs.selectTerminal.getTerminals();
          this.contactSeletions = this.$refs.selectContact.getContactData();
          if (
            this.terminalSelections.length <= 0 &&
            this.contactSeletions.length <= 0
          ) {
            this.$message.warning(this.$t("lang.alarmNotice.msg3"));
          } else if (this.terminalSelections.length <= 0) {
            this.$message.warning(this.$t("lang.alarmNotice.msg4"));
          } else if (this.contactSeletions.length <= 0) {
            this.$message.warning(this.$t("lang.alarmNotice.msg5"));
          } else {
            let dtus = this.terminalSelections.map((item) => {
              return {
                id: item.id,
              };
            });
            let alarmContacts = this.contactSeletions.map((item) => {
              return {
                id: item.id,
              };
            });
            this.$set(this.alarmNotice, "dtus", dtus);
            this.$set(this.alarmNotice, "alarmContacts", alarmContacts);
            let submitData = cloneDeep(this.alarmNotice);
            for (let [key, value] of this.contactMap) {
              if (
                this.alarmNotice.mode.sort().toString() == key.sort().toString()
              ) {
                submitData.mode = value;
              }
            }
            if (this.type === "edit") {
              editAlarmNotice(submitData)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.$message.success(this.$t("lang.alarmNotice.msg6"));
                    this.$emit("updateList");
                    this.dialogVisible = false;
                  } else {
                    this.$message.error(this.$t("lang.alarmNotice.msg7"));
                  }
                })
                .catch(() => {});
            } else {
              addAlarmNotice(submitData)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.$message.success(this.$t("lang.alarmNotice.msg8"));
                    this.$emit("updateList");
                    this.dialogVisible = false;
                  } else {
                    this.$message.error(this.$t("lang.alarmNotice.msg9"));
                  }
                })
                .catch(() => {});
            }
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.form-input {
  width: 4rem;
}
.alarm-form {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}
.tag-style {
  margin-right: 5px;
}
</style>
